module.exports = __webpack_public_path__ + "static/img/home_07.28c4227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/home_07.jpg
// module id = IdZX
// module chunks = 1